import file from './uniqueImageName.txt'
import './App.css';

import { useEffect, useState } from 'react';
import { GetObjectCommand, S3Client } from '@aws-sdk/client-s3';
import { getSignedUrl } from "@aws-sdk/s3-request-presigner"
import ReactPaginate from 'react-paginate';
import CreatePerson from './CreatePerson';

function Batch() {

  const creds = {
    accessKeyId: "AKIATELQNZIIKI4GPREU",
    secretAccessKey: "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",
  };

  const batches = require('./batchList.json');
  const someImages = require('./iteration2_images.json');

  const [somePosts, setSomePosts] = useState([])

  const [posts, setPosts] = useState([]);
  const [images, setImages] = useState([]);
  const [batch, setBatch] = useState(1)

  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(1);

  const imageURL = []
  const temp = []

  fetch(file)
  .then(r => r.text())

  const handleBatchChange = e => {
    setBatch(e.target.value);
  }

  const result = someImages.filter(obj => {
    return obj.batch === parseInt(batch)
  })

  const createPresignedUrlWithClient = ({ bucket, key }) => {
    const client = new S3Client({ region: "ca-central-1", credentials: creds });
    const command = new GetObjectCommand({ Bucket: bucket, Key: key });
    return getSignedUrl(client, command, { expiresIn: 3600 });
  };  

  useEffect(() => {
    setSomePosts(result)
    console.log(result)
  }, [batch])
  
  useEffect(() => {

    const getImageURL = async () => {
      console.log("Before loop");

      for(let index = 0; index < somePosts.length; index++) {
        const clientUrl = await createPresignedUrlWithClient({
          bucket: "interface-storage-d8e209c562552-staging",
          key: "public/all/"+somePosts[index].title,
        });
        // console.log("URL: ", clientUrl)

        let data = {
          title: somePosts[index].title,
          source: clientUrl,
          boxNum: somePosts[index].boxNum,
        }
        
        imageURL.push(data)
      }
      setImages(imageURL)
      console.log("After loop")
    };
    getImageURL()

  }, [somePosts]);

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = images.slice(indexOfFirstPost, indexOfLastPost);

  var currentPostTitle = ""

  const paginate = ({ selected }) => {
		setCurrentPage(selected + 1);
	};

  return (
    <div className="container">
      <div className="blog-content-section">
        <div className="container-grid">
            <div >
              <select value={batch} onChange={handleBatchChange}>
              {batches.map((item) => {return (<option key={item.batch} value={item.batch}>Batch {item.batch}</option>)})}
              </select>
              <h4>Batch {batch} has 15 images.</h4>
              <br />
                {currentPosts.map((currentPost) => {
                    currentPostTitle = currentPost.title;
                return (
                  <div className="blog-post" key={currentPost.title}>
                    <img className="cover-img" src={currentPost.source} alt="image not found" />
                    {/* <h4 className="title">Image Name</h4> */}
                    {/* <h4 className="description">{currentPost.title}</h4> */}
                  </div>)
                })}
            </div>
          <div className='col-2'>
            <CreatePerson
              imageSrc={currentPostTitle}
            />
          </div>
        </div>
        <ReactPaginate
          onPageChange={paginate}
          pageCount={Math.ceil(images.length / postsPerPage)}
          previousLabel={'Prev'}
          nextLabel={'Next'}
          containerClassName={'pagination'}
          pageLinkClassName={'page-number'}
          previousLinkClassName={'page-number'}
          nextLinkClassName={'page-number'}
          activeLinkClassName={'active'}
          />
      </div>
    </div>
  );
}

export default Batch;
